<v-sheet flat max-height="calc(100vh - 130px)" class="overflow-auto pa-4">
  <AlertBox
    v-if="isShowAlertBox"
    :alertDetail="alertDetail"
    @EmitCloseAlertBox="emitCloseAlertBox"
  ></AlertBox>
  <div id="chatBotContainer" ref="chatBotContainer" class="pb-0">
    <v-card flat class="">
      <v-app-bar
        flat
        class="border-b border-opacity-10 border-t-0 border-s-0 border-e-0 border-grey border-md bg-black-lighten-3"
        height="50"
      >
        <v-btn
          v-if="!aiChatBotKeys?.FeatureFlags?.IsEnableAdminBot"
          variant="text"
          size="32"
          @click="navigateToHome"
          rounded
          aria-label="Close chat box"
        >
          <v-icon class="fs-32px" role="img" aria-hidden="true"
            >mdi-chevron-left</v-icon
          >
          <v-tooltip activator="parent" location="bottom">
            Back to Home
          </v-tooltip>
        </v-btn>
        <v-app-bar-title class="font-weight-medium ms-1 align-center">
          <!-- <v-avatar v-if="!isLiveAgent" color="primary" class="me-1" size="30" >
            <v-icon color="white" size="20">mdi-robot-outline</v-icon>
          </v-avatar>
         <v-avatar v-else class="mt-2">
           <template v-if="liveAgentList.length>0 && filteredLiveAgentList.length>0">
            <template v-for="(item,i) in filteredLiveAgentList" :key="i"> 
            <v-img 
              :src="item.thumbnail"
            > </v-img>
            </template>
           </template>
           <template v-else>
           {{liveAgentList[0]?.name?.charAt(0)}}
           </template>
         </v-avatar> -->
          <p
            class="vertical-align-middle"
            :class="aiChatBotKeys?.FeatureFlags?.IsEnableAdminBot ? 'ml-2' : ''"
          >
            {{aiChatBotKeys?.BotName}}
          </p>
        </v-app-bar-title>
        <v-btn-toggle
          mandatory
          v-if="isEnableLiveAgent && !aiChatBotKeys?.FeatureFlags?.IsEnableAdminBot && isAIChatEnabled"
          v-model="buttonMode"
          color="black"
          density="compact"
          class="rounded-pill bg-primary overlay-transparent border"
          @update:modelValue="checkEmailAddressAvailable()"
        >
          <v-btn
            ><v-img
              src="../../assets/images/Bandit-chat-bot-star.svg"
              alt="Bandit Icon"
              width="10"
              max-width="15"
              id="aiid"
            ></v-img
            >AI</v-btn
          >
          <v-btn class="text-initial" id="liveagent">Live Agent </v-btn>
          <v-badge
            :content="NotificationCount"
            color="error"
            class="badge-above-toggle"
            v-if="NotificationCount"
          >
          </v-badge>
        </v-btn-toggle>

        <v-btn-toggle
          v-if="aiChatBotKeys?.FeatureFlags?.IsEnableAdminBot"
          mandatory
          v-model="buttonMode"
          color="black"
          density="compact"
          class="rounded-pill bg-primary overlay-transparent border"
          @update:modelValue="changeToAnotherBot()"
        >
          <v-btn class="text-initial"
            ><v-img
              src="../../assets/images/Bandit-chat-bot-star.svg"
              alt="Bandit Icon"
              width="10"
              max-width="15"
              id="aiid"
            ></v-img
            >Bot 1
            <v-tooltip activator="parent" location="bottom"
              >Bot with Docs and TBS Bot Data</v-tooltip
            >
          </v-btn>
          <v-btn class="text-initial" id="liveagent">
            <v-img
              src="../../assets/images/Bandit-chat-bot-star.svg"
              alt="Bandit Icon"
              width="10"
              max-width="15"
              id="aiid"
            ></v-img>
            <v-tooltip activator="parent" location="bottom"
              >Bot with Docs only
            </v-tooltip>
            Bot 2
          </v-btn>
        </v-btn-toggle>

        <v-btn
          id="menu-activator"
          color="black"
          icon="mdi-dots-vertical"
          size="30"
        >
        </v-btn>

        <v-menu activator="#menu-activator" offset="10 10">
          <v-list density="compact" class="py-0">
            <v-list-item class="min-h-auto py-2" @click="newChat()">
              New Chat
            </v-list-item>
            <v-divider color="disable opacity-1"></v-divider>
            <v-list-item
              class="min-h-auto py-2"
              @click="clearChat()"
              v-if="!isLiveAgent"
            >
              Clear Chat
            </v-list-item>
            <v-list-item
              v-if="isLiveAgent"
              class="min-h-auto py-2"
              @click="endChat()"
            >
              End Chat
            </v-list-item>
            <v-list-item
              class="min-h-auto py-2"
              @click="generatePDF()"
              v-if="aiChatBotKeys?.FeatureFlags?.IsEnableChatExport"
              :disabled="!hasEnableExportOption"
            >
              Export Chat
            </v-list-item>
            <v-list-item
              class="min-h-auto py-2"
              @click="isMaximizeWidget = !isMaximizeWidget"
            >
              {{isMaximizeWidget ? 'Collapse' : 'Expand'}} Widget
            </v-list-item>
            <v-divider color=" opacity-2"></v-divider>
            <!-- <div class="pa-2">Tools</div> -->
            <v-list-item
              class="min-h-auto py-2"
              @click="extractDocumentConverter()"
              v-if="!isLiveAgent && aiChatBotKeys?.FeatureFlags?.IsEnableChatExcelToCSVConverter"
            >
              Excel to CSV
            </v-list-item>
            <!-- <v-list-item class="">
              <div class="d-flex justify-space-between">
              <div>
               Converter
              </div>
              <v-btn
               variant="text"
               size="20"
               rounded
               id="converter-activator"
               aria-label="Close chat box"
             >
               <v-icon class="fs-20px" role="img" aria-hidden="true"
                 >mdi-chevron-right</v-icon
               >
               <v-tooltip activator="parent" location="bottom">
               Tools
               </v-tooltip>
             </v-btn>
                 </div>
 
                 <v-menu activator="#converter-activator" offset="10 10">
                   <v-list-item class="min-h-auto py-2" @click="extractDocumentConverter('zip')" v-if="!isLiveAgent">
                     ZIP to PDF
                   </v-list-item>
                   <v-list-item class="min-h-auto py-2" @click="enableValidateUSPSAddress()" v-if="!isLiveAgent">
                     USPS Validator
                   </v-list-item>
                   </v-menu>
             </v-list-item> -->
            <v-list-item
              class="min-h-auto py-2"
              @click="captureSnap()"
              v-if="isLiveAgent && aiChatBotKeys?.FeatureFlags?.IsEnableSnap"
            >
              Take Snap
            </v-list-item>
            <v-list-item
              class="min-h-auto py-2"
              @click="extractDocumentConverter('zip')"
              v-if="!isLiveAgent && aiChatBotKeys?.FeatureFlags?.IsEnableChatZipToPdfConverter"
            >
              ZIP to PDF
            </v-list-item>
            <v-list-item
              class="min-h-auto py-2"
              @click="enableValidateUSPSAddress()"
              v-if="!isLiveAgent && aiChatBotKeys?.FeatureFlags?.IsEnableAddressValidator"
            >
              Address Validator
            </v-list-item>
            <v-list-item
              class="min-h-auto py-2"
              @click="downloadSummaryPdf()"
              v-if="!isLiveAgent && aiChatBotKeys?.FeatureFlags?.IsEnableDownloadSummaryPdf"
            >
              Download Summary Pdf
            </v-list-item>
            <!-- <v-list-item class="min-h-auto py-2" @click="enableCheckReturnStatus()"  v-if="!isLiveAgent ">
             Check Return Status
            </v-list-item> -->
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-stepper v-model="stepperElement" elevation="0" class="bg-transparent">
        <template>
          <v-stepper-item
            :complete="stepperElement > 0"
            step="1"
          ></v-stepper-item>
          <v-stepper-item
            :complete="stepperElement > 1"
            step="2"
          ></v-stepper-item>
        </template>
        <v-stepper-window class="overflow-visible ma-0 bg-transparent">
          <v-stepper-window-item value="1" class="bg-transparent">
            <!-- Chat History -->
            <div id="aichat-to-print">
              <div class="greeting">
                <div class="d-flex justify-center">
                  <v-img
                    class="me-2"
                    v-if="BotIconPath"
                    alt="Bandit AI"
                    width="60"
                    max-width="60"
                    :src="BotIconPath"
                  ></v-img>
                  <div v-else class="w-50px">
                    <ChatStarIcon></ChatStarIcon>
                  </div>
                </div>
                <div class="font-weight-medium fs-16px text-center">
                  {{getAIFeatureContents.AIAgent}}
                </div>
                <p class="text-grey fs-14px text-center mb-3">
                 {{getAIFeatureContents.LiveAgentNeeded}}
                </p>
              </div>
              <div
                v-for="(message, index) in oldAIChatConversationDetails"
                :key="index"
                class="mb-3"
              >
                <div class="d-flex justify-end">
                  <div v-if="message.Question.Attachments">
                    <div
                      v-for="(item,index) in message.Question.Attachments"
                      :key="index"
                    >
                      <v-img width="80" height="80" :src="item.DataUrl"></v-img>
                    </div>
                  </div>
                  <v-card
                    flat
                    :color="message.Question.Attachments?.length>0 ? 'grey-lighten-1' : 'black'"
                    class="message-bubble"
                    v-if="message.Question.Content || message.Question.Attachments?.length>0"
                  >
                    <v-card-text class="pa-2 rounded text-white">
                      {{ message.Question.Content }}
                      <div
                        v-if="message.Question.Attachments?.length>0"
                        class="csv-card"
                      >
                        <div class="card-content">
                          <div
                            v-for="(item, index) in message.Question.Attachments"
                            :key="index"
                            class="attachment-item"
                          >
                            <div class="item-content">
                              <h3 class="file-name">
                                {{ extractFileName(item.DataUrl)
                                }}{{extractFileExtenstion(item.DataUrl,'extension')}}
                                <v-tooltip activator="parent" location="bottom">
                                  {{extractFileName(item.DataUrl)
                                  }}{{extractFileExtenstion(item.DataUrl,'extension')}}</v-tooltip
                                >
                              </h3>
                              <a :href="item.DataUrl" download>
                                <v-icon>mdi-download</v-icon>
                              </a>
                            </div>
                            <div
                              v-if="index < message.Answer.Attachments?.length - 1"
                              class="half-separator"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <div class="mt-3">
                  <div class="d-flex align-start">
                    <v-img
                      class="me-2"
                      v-if="BotIconPath && isTaxBandits"
                      alt="Bandit AI"
                      width="25"
                      max-width="30"
                      :src="BotBatchIcon"
                    ></v-img>
                    <div v-else class="w-50px">
                      <ChatStarIcon></ChatStarIcon>
                    </div>
                    <v-card
                      flat
                      color="1"
                      class="message-bubble"
                      v-if="message.Answer.Content || message.Answer.Attachments?.length>0"
                    >
                      <v-card-text
                        class="pa-2 rounded text-black bg-grey-lighten-3 pa-2 position-relative"
                      >
                        <BotResponse
                          :Text="message.Answer.Content"
                          :IsAllowTypeFormatter="isAllowTypeFormatter"
                        />
                        <div
                          v-if="message.Answer.Attachments?.length>0"
                          class="csv-card"
                        >
                          <div class="card-content">
                            <div
                              v-for="(item, index) in message.Answer.Attachments"
                              :key="index"
                              class="attachment-item"
                            >
                              <div class="item-content">
                                <h3 class="file-name">
                                  {{ extractFileName(item.DataUrl)
                                  }}{{extractFileExtenstion(item.DataUrl,'extension')}}
                                  <v-tooltip
                                    activator="parent"
                                    location="bottom"
                                  >
                                    {{extractFileName(item.DataUrl)
                                    }}{{extractFileExtenstion(item.DataUrl,'extension')}}</v-tooltip
                                  >
                                </h3>
                                <a :href="item.DataUrl" download>
                                  Download
                                  <!-- <v-icon>mdi-download</v-icon> -->
                                </a>
                              </div>
                              <div
                                v-if="index < message.Answer.Attachments?.length - 1"
                                class="half-separator"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div v-if="message.IsAiChat" class="mt-2">
                          <v-divider></v-divider>
                          <v-card
                            flat
                            class="bg-grey-lighten-3 pa-2 position-relative"
                          >
                            <div
                              class="d-flex align-start justify-space-between"
                            >
                              <div class="d-flex align-center">
                                <span class="">
                                  <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 16 15"
                                    fill="none"
                                    class="mt-1"
                                  >
                                    <rect
                                      width="16"
                                      height="14"
                                      y="0.5"
                                      fill="currentColor"
                                      rx="4"
                                    ></rect>
                                    <path
                                      fill="#fff"
                                      d="M6.181 11.1H7.9L6.142 4.9H4.213L2.46 11.1h1.564l.297-1.362h1.572zM5.077 6.296h.082l.49 2.307h-1.08zm7.635 4.804V9.832h-1.306V6.167h1.306V4.899H8.527v1.268h1.307v3.665H8.527V11.1z"
                                    ></path>
                                  </svg>
                                </span>
                                <span class="ms-1 text-grey fs-14px"
                                  >Answer</span
                                >
                              </div>

                              <div class="d-flex justify-space-between">
                                <span class="mr-2">
                                  <v-hover>
                                    <template
                                      v-slot:default="{ isHovering, props }"
                                    >
                                      <div
                                        v-if="message.Answer.YoutubeLink"
                                        class="youtube-preview"
                                        v-bind="props"
                                      >
                                        <a
                                          :href="message.Answer.YoutubeLink"
                                          target="_blank"
                                          class="youtube-link"
                                        >
                                          <v-icon
                                            :color="isHovering ? 'primary' : '#FF0000'"
                                            >mdi-youtube</v-icon
                                          >
                                          <v-tooltip
                                            location="bottom"
                                            activator="parent"
                                          >
                                            Watch on youtube
                                          </v-tooltip>
                                        </a>
                                      </div>
                                    </template>
                                  </v-hover>
                                </span>
                                <span>
                                  <v-tooltip text="Tooltip" location="bottom">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props" class="fs-20px"
                                        >mdi-information-outline</v-icon
                                      >
                                    </template>
                                    <span>
                                      AI-generated responses are for general
                                      assistance. Please double-check responses.
                                    </span>
                                  </v-tooltip>
                                </span>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="ml-12 mt-1 chatai">
                    <v-btn
                      icon
                      variant="text"
                      size="25"
                      color="grey"
                      @click="isPlaying && message.MessageId == speakMessageId ? stop() : readAloud(message.Answer.Content,message.MessageId)"
                    >
                      <v-icon class="fs-20px"
                        >{{isPlaying && message.MessageId == speakMessageId ?
                        'mdi-stop-circle' : 'mdi-volume-high' }}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Read aloud</v-tooltip
                      >
                    </v-btn>

                    <v-btn
                      icon
                      variant="text"
                      size="25"
                      color="grey"
                      @click="copyMessage(message)"
                    >
                      <v-icon class="fs-20px"
                        >{{copied && messageId == message.MessageId ?
                        'mdi-clipboard-check-outline' :
                        'mdi-clipboard-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Copy</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      size="25"
                      variant="text"
                      @click="message.Commends == 'Good' ? '' :thumbsCommends('Good',message.MessageId,'OldChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.Commends == 'Good' ? 'mdi-thumb-up' :
                        'mdi-thumb-up-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Like</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      size="25"
                      variant="text"
                      @click="message.Commends == 'Bad' ? '' :thumbsCommends('Bad',message.MessageId,'OldChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.Commends == 'Bad' ? 'mdi-thumb-down' :
                        'mdi-thumb-down-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Dislike</v-tooltip
                      >
                    </v-btn>
                  </div>
                </div>
              </div>

              <!-- AI Chat Conversations -->

              <template
                v-for="(message, index) in ChatMessageDetails"
                :key="index"
              >
                <v-card
                  flat
                  class="mb-4 chatai"
                  :class="[ 
                ChatMessageDetails.length - 1 == index &&  message.senderType === 'User'? 'bot-height-1' : 
                ChatMessageDetails.length - 2 == index  && message.senderType != 'Bot' ? 'bot-height ' : ''
                ]"
                >
                  <div
                    class="d-flex align-start hover-div"
                    :class="message.senderType === 'User' ? 'justify-end' : ''"
                  >
                    <div
                      class="tooltip"
                      style="z-index: 999"
                      v-if="ChatMessageDetails?.length - 1 != index"
                    >
                      {{formatTime(message.createdAt)}}
                    </div>
                    <!-- Bot Avatar -->
                    <!-- <v-avatar
                  v-if="message.senderType === 'Bot'"
                  color="white"
                  class="mr-2"
                  size="45"
                > -->
                    <template v-if="message.senderType === 'Bot'">
                      <v-img
                        class="me-2"
                        v-if="BotIconPath && isTaxBandits"
                        alt="Bandit AI"
                        width="25"
                        max-width="30"
                        :src="BotBatchIcon"
                      ></v-img>
                      <div v-else class="w-50px">
                        <ChatStarIcon></ChatStarIcon>
                      </div>
                    </template>
                    <!-- </v-avatar> -->

                    <!-- Message Bubble -->
                    <v-card
                      flat
                      :class="message.senderType === 'User' ? '' : ''"
                      :color="message.senderType === 'User' ?(message.attachments?.length>0 ? 'grey-lighten-1'  :'black') : message.color == 'Yellow' ? 'grey-lighten-3': 'grey-lighten-3'"
                      class="message-bubble position-relative"
                      :max-width="message.senderType === 'User' ? '270px' : ''"
                    >
                      <v-card-text
                        class="rounded"
                        :class="message.senderType === 'User' ? 'text-white pa-2' : 'text-black pa-2'"
                      >
                        <span v-if="message.senderType === 'User'">
                          {{ message.text }}
                        </span>
                        <span v-else>
                          <span v-if="message.isWelcomeMessage">
                            <div v-html="message.text"></div>
                            <!-- {{message.text}} -->
                          </span>
                          <BotResponse
                            v-else
                            :Text="message.text"
                            :IsAllowTypeFormatter="isAllowTypeFormatter"
                            @ScrollToBottom="scrollToBottom"
                            @TypingCompleted="isTypingCompleted = true"
                            :IsScrollToBottom="userAIChatCount<=2"
                          />
                        </span>

                        <div v-if="message.attachments" class="csv-card">
                          <div class="card-content">
                            <div
                              v-for="(item, index) in message.attachments"
                              :key="index"
                              class="attachment-item"
                            >
                              <div class="item-content">
                                <h3 class="file-name">
                                  {{ item.SheetName ? item.SheetName :
                                  extractFileName(item.DataUrl)
                                  }}{{extractFileExtenstion(item.DataUrl)}}
                                  <v-tooltip
                                    activator="parent"
                                    location="bottom"
                                  >
                                    {{ item.SheetName ? item.SheetName :
                                    extractFileName(item.DataUrl)
                                    }}{{extractFileExtenstion(item.DataUrl)}}
                                  </v-tooltip>
                                </h3>
                                <a
                                  :href="checkDownloadUrlIsExpiredOrNot(item.DataUrl)? showExpiredAlert() : item.DataUrl "
                                  class="download-link"
                                  download
                                >
                                  Download
                                  <!-- <v-icon>mdi-download</v-icon> -->
                                </a>
                              </div>
                              <div
                                v-if="index < message.attachments.length - 1"
                                class="half-separator"
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div v-if="message?.isShowAnotherFileUpload" class="pa-2 ml-1">
                          <a
                            href="javascript:void(0)"
                            @click="extractDocumentConverter(message?.type)"
                            >{{message?.type == "zip" ? "Upload & Convert Another ZIP" : "Upload & Convert Another Excel"}}</a
                          >
                        </div>
                        <div
                          v-if="message.senderType === 'Bot' && !message.isWelcomeMessage &&  message.color != 'Yellow'"
                          class="mt-2"
                        >
                          <div
                            class="chat-message"
                            v-if="message.isShowYoutubeReference"
                          >
                            <!-- YouTube Thumbnail -->
                            <div v-if="message.youtubeLink">
                              <a
                                :href="message.youtubeLink"
                                target="_blank"
                                class="text-decoration-none d-flex align-center"
                              >
                                <div class="position-relative">
                                  <img
                                    width="80"
                                    :src="message.youtubeThumbnail"
                                    alt="YouTube Thumbnail"
                                    class="curve-image"
                                  />
                                  <v-icon
                                    color="#FF0000"
                                    style="
                                      position: absolute;
                                      left: 34%;
                                      right: 0px;
                                      top: 29%;
                                      background: #fff;
                                    "
                                    >mdi-youtube</v-icon
                                  >
                                </div>
                                <!-- <div class="play-icon">▶</div> -->
                                <v-btn
                                  variant="outlined"
                                  color="#FF0000"
                                  class="text-initial ms-4"
                                  >Watch on youtube
                                  <v-icon right class="mt-1"
                                    >mdi-play</v-icon
                                  ></v-btn
                                >
                              </a>
                              <!-- <div class="youtube-title d-flex">Watch on YouTube</div> -->
                            </div>
                          </div>
                          <v-divider
                            v-if="ChatMessageDetails.length-1 == index && !isStreamingProcessing "
                          ></v-divider>
                          <v-card
                            flat
                            class="1 pa-2 bg-disable"
                            v-if="ChatMessageDetails.length-1 == index && !isStreamingProcessing "
                          >
                            <div class="d-flex justify-space-between">
                              <div class="d-flex align-center">
                                <span class="">
                                  <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 16 15"
                                    fill="none"
                                    class="mt-1"
                                  >
                                    <rect
                                      width="16"
                                      height="14"
                                      y="0.5"
                                      fill="currentColor"
                                      rx="4"
                                    ></rect>
                                    <path
                                      fill="#fff"
                                      d="M6.181 11.1H7.9L6.142 4.9H4.213L2.46 11.1h1.564l.297-1.362h1.572zM5.077 6.296h.082l.49 2.307h-1.08zm7.635 4.804V9.832h-1.306V6.167h1.306V4.899H8.527v1.268h1.307v3.665H8.527V11.1z"
                                    ></path>
                                  </svg>
                                </span>
                                <span class="ms-1 fs-14px text-grey"
                                  >Answer</span
                                >
                              </div>
                              <div>
                                <v-tooltip text="Tooltip">
                                  <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" class="fs-20px">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>
                                    AI-generated responses are for general
                                    assistance. Please double-check responses.
                                  </span>
                                </v-tooltip>
                              </div>
                            </div>
                          </v-card>
                        </div>
                        <div
                          class="text-center mt-3"
                          v-if="message?.isShowFileUpload"
                        >
                          <v-file-upload
                            v-if="excelDocument?.length == 0 || !excelDocument"
                            v-model="excelDocument"
                            clearable
                            show-size
                            :accept="message?.type"
                            density="compact"
                            title="Drag and Drop Here"
                            @update:modelValue="handleFileUploadChange(message?.type)"
                          >
                            <template v-slot:item="{ props: itemProps }">
                              <v-file-upload-item
                                v-bind="itemProps"
                                lines="one"
                                nav
                              >
                                <template v-slot:prepend>
                                  <v-avatar size="32" rounded></v-avatar>
                                </template>

                                <template v-slot:clear="{ props: clearProps }">
                                  <v-btn
                                    color="primary"
                                    v-bind="clearProps"
                                  ></v-btn>
                                </template>
                              </v-file-upload-item>
                            </template>
                          </v-file-upload>

                          <v-card
                            v-if="excelDocument.length > 0"
                            class="mx-auto pa-2 bg-grey-lighten-3 mb-2"
                            max-width="300"
                          >
                            <template
                              v-for="(item,index) in excelDocument"
                              :key="index"
                            >
                              <v-row align="center" no-gutters class="">
                                <v-avatar size="24" class="mr-2">
                                  <v-icon icon="mdi-file" size="18"></v-icon>
                                </v-avatar>

                                <span
                                  class="text-body-2 text-truncate flex-grow-1"
                                  style="max-width: 210px"
                                >
                                  {{ excelDocument[0]?.name }}
                                </span>
                                <v-btn
                                  icon="mdi-close"
                                  size="x-small"
                                  class=" "
                                  variant="text"
                                  @click="excelDocument = []"
                                ></v-btn>
                              </v-row>
                            </template>
                          </v-card>

                          <v-btn
                            :disabled="isUploadButtonLoading || isWaitingLoader"
                            :loading="isUploadButtonLoading"
                            variant="flat"
                            size="large"
                            color="success"
                            class="text-initial text-no-wrap px-8"
                            @click="extractDocument(message?.type)"
                            v-if="excelDocument.length >0"
                          >
                            Upload
                            <template v-slot:loader>
                              <v-progress-circular
                                color="grey-lighten-1"
                                indeterminate
                                size="16"
                                width="2"
                                class="me-2"
                              ></v-progress-circular
                              >Upload
                            </template>
                          </v-btn>
                          <v-alert
                            v-if="message?.type.includes('zip')"
                            class="pa-2 mt-2 text-black"
                          >
                            <span class="mdi mdi-information-outline"></span
                            ><span class="ml-1">
                              <b>Note:</b> Only PDF format files are allowed; no
                              other formats are accepted.</span
                            ></v-alert
                          >
                        </div>
                        <v-card v-if="message?.isShowSummaryPdf">
                          <v-card-text>
                            <v-row class="mt-2" no-gutters>
                              <v-col class="">
                                <label class="text-grey fs-14px"
                                  >Business Name</label
                                >
                                <v-text-field
                                  v-model="summaryFormPdf.BusinessName"
                                  @input="v$.summaryFormPdf.BusinessName.$touch()"
                                  @blur="v$.summaryFormPdf.BusinessName.$touch()"
                                  :error="v$.summaryFormPdf.BusinessName.$error"
                                  :error-messages="v$.summaryFormPdf.BusinessName.$errors[0]?.$message"
                                  variant="outlined"
                                  density="compact"
                                  maxLength="100"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                ></v-text-field
                              ></v-col>
                            </v-row>
                            <v-row class="mt-2" no-gutters>
                              <v-col class="">
                                <label class="text-grey fs-14px"
                                  >TIN Type</label
                                >
                                <v-select
                                  v-model="summaryFormPdf.TINTypes"
                                  @input="v$.summaryFormPdf.TINTypes.$touch()"
                                  @blur="v$.summaryFormPdf.TINTypes.$touch()"
                                  :error="v$.summaryFormPdf.TINTypes.$error"
                                  :error-messages="v$.summaryFormPdf.TINTypes.$errors[0]?.$message"
                                  variant="outlined"
                                  density="compact"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                  maxLength="50"
                                  :items="TINTypes"
                                  item-title="key"
                                  item-value="value"
                                ></v-select
                              ></v-col>
                            </v-row>
                            <v-row class="mt-2" no-gutters>
                              <v-col class="">
                                <label class="text-grey fs-14px"
                                  >{{summaryFormPdf.TINTypes}}</label
                                >
                                <v-text-field
                                  v-model="summaryFormPdf.EIN"
                                  @input="v$.summaryFormPdf.EIN.$touch()"
                                  @blur="v$.summaryFormPdf.EIN.$touch()"
                                  :error="v$.summaryFormPdf.EIN.$error"
                                  :error-messages="v$.summaryFormPdf.EIN.$errors[0]?.$message"
                                  variant="outlined"
                                  density="compact"
                                  maxLength="100"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                  v-mask="mask"
                                ></v-text-field
                              ></v-col>
                            </v-row>
                            <v-row no-gutters class="mt-2">
                              <v-col>
                                <label class="text-grey fs-14px"
                                  >Form Type</label
                                >
                                <v-select
                                  v-model="summaryFormPdf.FormId"
                                  @input="v$.summaryFormPdf.FormId.$touch()"
                                  @blur="v$.summaryFormPdf.FormId.$touch()"
                                  :error="v$.summaryFormPdf.FormId.$error"
                                  :error-messages="v$.summaryFormPdf.FormId.$errors[0]?.$message"
                                  maxLength="50"
                                  :items="FormType"
                                  item-title="key"
                                  item-value="value"
                                  variant="outlined"
                                  density="compact"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                ></v-select
                              ></v-col>
                            </v-row>
                            <v-row no-gutters class="mt-2">
                              <v-col>
                                <label class="text-grey fs-14px"
                                  >Tax Year</label
                                >
                                <v-select
                                  v-model="summaryFormPdf.TaxYear"
                                  :items="TaxYear"
                                  variant="outlined"
                                  density="compact"
                                  @input="v$.summaryFormPdf.TaxYear.$touch()"
                                  @blur="v$.summaryFormPdf.TaxYear.$touch()"
                                  :error="v$.summaryFormPdf.TaxYear.$error"
                                  :error-messages="v$.summaryFormPdf.TaxYear.$errors[0]?.$message"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                ></v-select
                              ></v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <div>
                              <v-btn
                                variant="flat"
                                size="large"
                                :disabled="isGeneratePdfButtonLoader"
                                :loading="isGeneratePdfButtonLoader"
                                class="text-capitalize text-no-wrap px-4"
                                @click="generatePDFSubmit"
                                color="primary"
                              >
                                Generate Pdf
                                <template v-slot:loader>
                                  <v-progress-circular
                                    color="grey-lighten-1"
                                    indeterminate
                                    size="16"
                                    width="2"
                                  ></v-progress-circular>
                                  Generate Pdf
                                </template>
                              </v-btn>
                            </div>
                          </v-card-actions>
                        </v-card>

                        <v-card v-if="message?.isCheckReturnStatus">
                          <v-card-text>
                            <v-row class="mt-2" no-gutters>
                              <v-col class="">
                                <label class="text-grey fs-14px"
                                  >Employer(or) Payer(or) Business TIN</label
                                >
                                <v-text-field
                                  v-model="returnStatus.BusinessEIN"
                                  @input="v$.returnStatus.BusinessEIN.$touch()"
                                  @blur="v$.returnStatus.BusinessEIN.$touch()"
                                  :error="v$.returnStatus.BusinessEIN.$error"
                                  :error-messages="v$.returnStatus.BusinessEIN.$errors[0]?.$message"
                                  variant="outlined"
                                  density="compact"
                                  maxLength="100"
                                  class="mt-0 pt-0 position-relative text-tertiary"
                                  hide-details="auto"
                                  v-mask="'##-#######'"
                                ></v-text-field
                              ></v-col>
                            </v-row>
                            <v-divider
                              color="disable opacity-1  my-2"
                              thickness="2"
                            ></v-divider>
                            <div class="ml-1">
                              <v-row class="mt-2" no-gutters>
                                <v-col class="">
                                  <label class="text-grey fs-14px"
                                    >Employee(or) payee(or) Recipient Name,
                                  </label>
                                  <v-text-field
                                    v-model="returnStatus.RecipientName"
                                    @input="v$.returnStatus.RecipientName.$touch()"
                                    @blur="v$.returnStatus.RecipientName.$touch()"
                                    :error="v$.returnStatus.RecipientName.$error"
                                    :error-messages="v$.returnStatus.RecipientName.$errors[0]?.$message"
                                    variant="outlined"
                                    density="compact"
                                    maxLength="100"
                                    class="mt-0 pt-0 position-relative text-tertiary"
                                    hide-details="auto"
                                  ></v-text-field
                                ></v-col>
                              </v-row>

                              <v-row no-gutters class="mt-2">
                                <v-col>
                                  <label class="text-grey fs-14px"
                                    >Last Four Digit TIN or SSN</label
                                  >
                                  <v-text-field
                                    v-model="returnStatus.LastFourDigitRecipientTIN"
                                    @input="v$.returnStatus.LastFourDigitRecipientTIN.$touch()"
                                    @blur="v$.returnStatus.LastFourDigitRecipientTIN.$touch()"
                                    :error="v$.returnStatus.LastFourDigitRecipientTIN.$error"
                                    :error-messages="v$.returnStatus.LastFourDigitRecipientTIN.$errors[0]?.$message"
                                    variant="outlined"
                                    density="compact"
                                    maxLength="100"
                                    class="mt-0 pt-0 position-relative text-tertiary"
                                    hide-details="auto"
                                    v-mask="'####'"
                                  ></v-text-field
                                ></v-col>
                              </v-row>
                            </div>
                          </v-card-text>
                          <v-card-actions class="justify-center">
                            <div>
                              <v-btn
                                variant="flat"
                                size="large"
                                :disabled="isCheckReturnStatusButtonLoader"
                                :loading="isCheckReturnStatusButtonLoader"
                                class="text-capitalize text-no-wrap px-4"
                                @click="checkReturnStatus"
                                color="primary"
                              >
                                Check Return Status
                                <template v-slot:loader>
                                  <v-progress-circular
                                    color="grey-lighten-1"
                                    indeterminate
                                    size="16"
                                    width="2"
                                  ></v-progress-circular>
                                  Check Return Status
                                </template>
                              </v-btn>
                            </div>
                          </v-card-actions>
                        </v-card>

                        <!--USPS Validator-->
                        <v-card class="pa-2" v-if="message?.isUSPSValidator">
                          <v-row no-gutters class="mt-2">
                            <v-col>
                              <v-textarea
                                v-model="uspsAddress"
                                label="Address"
                                row-height="25"
                                rows="2"
                                variant="outlined"
                                auto-grow
                                shaped
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <div class="d-flex justify-center">
                            <v-btn
                              variant="flat"
                              size="large"
                              :disabled="isUSPSAddressButtonLoader || uspsAddress?.trim().length==0 "
                              :loading="isUSPSAddressButtonLoader"
                              class="text-capitalize text-no-wrap"
                              color="primary"
                              @click="validateAddress"
                            >
                              Validate
                              <template v-slot:loader>
                                <v-progress-circular
                                  color="grey-lighten-1"
                                  indeterminate
                                  size="16"
                                  width="2"
                                ></v-progress-circular>
                                Validate
                              </template>
                            </v-btn>
                          </div>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div
                    v-if="ChatMessageDetails.length-1 == index && message.senderType === 'Bot' && !isStreamingProcessing && !message.isShowFileUpload"
                    class="ms-12 mt-n fs-12px text-grey d-inline-block"
                  >
                    Bot {{formatTime(message.createdAt)}}
                  </div>
                  <div
                    v-if="message.senderType === 'Bot' && message.color !='Yellow' && !message.isWelcomeMessage && !message.isShowYoutubeReference && !isStreamingProcessing && !message.isShowFileUpload"
                    class="ml-12 mt-1"
                  >
                    <v-btn
                      icon
                      color="grey"
                      size="25"
                      variant="text"
                      @click="isPlaying && message.messageId == speakMessageId ? stop() : readAloud(message.text,message.messageId)"
                    >
                      <v-icon class="fs-20px"
                        >{{isPlaying && message.messageId == speakMessageId ?
                        'mdi-stop-circle' : 'mdi-volume-high' }}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Read aloud</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      variant="text"
                      size="25"
                      @click="copyMessage(message)"
                    >
                      <v-icon class="fs-20px"
                        >{{copied && messageId == message.messageId ?
                        'mdi-clipboard-check-outline' :
                        'mdi-clipboard-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Copy</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      variant="text"
                      size="25"
                      @click="message.commends == 'Good' ? '' :thumbsCommends('Good',message.messageId,'AIChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.commends == 'Good' ? 'mdi-thumb-up' :
                        'mdi-thumb-up-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Like</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      variant="text"
                      size="25"
                      @click="message.commends == 'Bad' ? '' :thumbsCommends('Bad',message.messageId,'AIChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.commends == 'Bad' ? 'mdi-thumb-down' :
                        'mdi-thumb-down-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Dislike</v-tooltip
                      >
                    </v-btn>
                  </div>
                </v-card>
              </template>

              <!-- <div>
              <iframe 
              height="100%"
              width="100%"
              frameborder="0"
              title="Calculator"
              src="https://tbsnew.spanplan.net/volume_based_calculator" >
                
              </iframe>
            </div> -->
            </div>
            <!-- Typing Indicator -->
            <div class="" v-if="isWaitingLoader">
              <!-- <v-avatar color="black" class="mr-2" size="35"> -->
              <!-- <v-icon color="white">mdi-emoticon</v-icon>
                    </v-avatar>
                    <div class="thinking-typing">Thinking...</div> -->
              <v-card
                flat
                class="d-flex align-start mb-3"
                min-height="calc(100vh  - 210px)"
              >
                <template v-if="BotIconPath && isTaxBandits">
                  <v-progress-circular
                    size="30"
                    width="2"
                    color="primary"
                    indeterminate
                  >
                    <template v-slot:default>
                      <v-img
                        class=""
                        alt="Bandit AI"
                        width="19"
                        max-width="30"
                        :src="BotBatchIcon"
                      ></v-img
                    ></template>
                  </v-progress-circular>
                  <div class="flex-grow-1">
                    <v-skeleton-loader type="paragraph"></v-skeleton-loader>
                  </div>
                </template>
                <template v-else>
                  <ThinkingLoader></ThinkingLoader>
                </template>
              </v-card>
            </div>
          </v-stepper-window-item>
          <v-stepper-window-item value="2" class="">
            <div id="livechat-to-print">
              <div
                class="greeting"
                v-if="LiveAgentChatMessageDetails.length ==0"
              >
                <div class="d-flex justify-center">
                  <v-img
                    width="60"
                    max-width="60"
                    v-if="BotIconPath"
                    :src="BotIconPath"
                  >
                  </v-img>
                  <div v-else class="w-100px">
                    <ChatStarIcon></ChatStarIcon>
                  </div>
                </div>
                <div class="font-weight-medium fs-16px text-center">
                  Welcome to {{isTaxBandits ? 'TaxBandits' :
                  capitalizeFirstWord(UserDetails?.Product)}} customer support
                </div>
                <p class="text-grey fs-14px text-center mb-3">
                  How can we help you?
                </p>
              </div>
              <div
                v-for="(message, index) in oldLiveChatConversationDetails"
                :key="index"
                class="mb-3"
              >
                <div class="d-flex justify-end">
                  <div v-if="message.Question.Attachments">
                    <div
                      v-for="(item,index) in message.Question.Attachments"
                      :key="index"
                    >
                      <v-img width="80" height="80" :src="item.DataUrl"></v-img>
                    </div>
                  </div>
                  <v-card
                    flat
                    color="black"
                    class="message-bubble"
                    v-if="message.Question.Content"
                  >
                    <v-card-text class="pa-2 rounded text-white">
                      {{ message.Question.Content }}
                    </v-card-text>
                  </v-card>
                </div>

                <div class="mt-3">
                  <div class="d-flex align-start">
                    <v-card flat tile class="bg-transparent overflow-visible">
                      <v-avatar color="grey" class="mr-2" size="35">
                        <v-img
                          v-if="message.liveAgentAvatar"
                          :src="message.liveAgentAvatar"
                          width="80"
                          height="80"
                        >
                        </v-img>
                        <span v-else>
                          <span v-if="message.Answer?.LiveAgentName">
                            {{message.Answer?.LiveAgentName?.charAt(0)}}
                          </span>
                          <v-icon v-else>mdi-emoticon</v-icon>
                        </span>
                      </v-avatar>
                    </v-card>
                    <div v-if="message.Answer.Attachments">
                      <div
                        v-for="(item,index) in message.Answer.Attachments"
                        :key="index"
                      >
                        <v-img
                          width="80"
                          height="80"
                          :src="item.DataUrl"
                        ></v-img>
                      </div>
                    </div>
                    <v-card
                      flat
                      color="1"
                      class="message-bubble"
                      v-if="message.Answer.Content"
                    >
                      <v-card-text
                        class="pa-2 rounded text-black bg-grey-lighten-3 pa-2 position-relative"
                      >
                        <BotResponse
                          :Text="message.Answer.Content"
                          :IsAllowTypeFormatter="isAllowTypeFormatter"
                        />
                        <!-- {{ message.Answer }} -->
                        <div class="mt-2" v-if="message.Answer.YoutubeLink">
                          <v-divider></v-divider>
                          <v-card
                            flat
                            class="bg-grey-lighten-3 pa-2 position-relative"
                          >
                            <div
                              class="d-flex align-start justify-space-between"
                            >
                              <div class="d-flex justify-space-between">
                                <span class="mr-2">
                                  <v-hover>
                                    <template
                                      v-slot:default="{ isHovering, props }"
                                    >
                                      <div
                                        v-if="message.Answer.YoutubeLink"
                                        class="youtube-preview"
                                        v-bind="props"
                                      >
                                        <a
                                          :href="message.Answer.YoutubeLink"
                                          target="_blank"
                                          class="youtube-link"
                                        >
                                          <v-icon
                                            :color="isHovering ? 'primary' : '#FF0000'"
                                            >mdi-youtube</v-icon
                                          >
                                          <v-tooltip
                                            location="bottom"
                                            activator="parent"
                                          >
                                            Watch on youtube
                                          </v-tooltip>
                                        </a>
                                      </div>
                                    </template>
                                  </v-hover>
                                </span>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div class="ml-12 mt-1 chatai">
                    <v-btn
                      icon
                      variant="text"
                      size="25"
                      color="grey"
                      @click="isPlaying && message.MessageId == speakMessageId ? stop() : readAloud(message.Answer.Content,message.MessageId)"
                    >
                      <v-icon class="fs-20px"
                        >{{isPlaying && message.MessageId == speakMessageId ?
                        'mdi-stop-circle' : 'mdi-volume-high' }}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Read aloud</v-tooltip
                      >
                    </v-btn>

                    <v-btn
                      icon
                      variant="text"
                      size="25"
                      color="grey"
                      @click="copyMessage(message)"
                    >
                      <v-icon class="fs-20px"
                        >{{copied && messageId == message.MessageId ?
                        'mdi-clipboard-check-outline' :
                        'mdi-clipboard-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Copy</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      size="25"
                      variant="text"
                      @click="message.Commends == 'Good' ? '' :thumbsCommends('Good',message.MessageId,'OldChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.Commends == 'Good' ? 'mdi-thumb-up' :
                        'mdi-thumb-up-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Like</v-tooltip
                      >
                    </v-btn>
                    <v-btn
                      icon
                      color="grey"
                      size="25"
                      variant="text"
                      @click="message.Commends == 'Bad' ? '' :thumbsCommends('Bad',message.MessageId,'OldChat')"
                    >
                      <v-icon class="fs-20px"
                        >{{message.Commends == 'Bad' ? 'mdi-thumb-down' :
                        'mdi-thumb-down-outline'}}</v-icon
                      >
                      <v-tooltip activator="parent" location="bottom"
                        >Dislike</v-tooltip
                      >
                    </v-btn>
                  </div>
                </div>
              </div>
              <div
                v-for="(message, index) in LiveAgentChatMessageDetails"
                :key="index"
                class="mb-4 chatai"
              >
                <div
                  class="d-flex align-start"
                  :class="message.senderType === 'User' ? 'justify-end' : ''"
                >
                  <!-- Bot Avatar -->
                  <v-avatar
                    v-if="message.senderType === 'LiveAgent' && message.color == 'Yellow'"
                    color="grey"
                    class="mr-2 fs-14px lh-1"
                    size="35"
                  >
                    <v-icon>mdi-emoticon</v-icon>
                  </v-avatar>
                  <v-card
                    flat
                    tile
                    class="bg-transparent overflow-visible"
                    v-if="message.color !== 'Yellow'"
                  >
                    <v-avatar
                      color="grey"
                      class="mr-2"
                      size="35"
                      v-if="message.senderType === 'LiveAgent' && (!IsNullorWhiteSpace(message.text) || Object.keys(message.attachments??{}).length !=0 )"
                    >
                      <v-img
                        v-if="message.liveAgentAvatar"
                        :src="message.liveAgentAvatar"
                        width="80"
                        height="80"
                      >
                      </v-img>
                      <span v-else> {{message.liveAgentName?.charAt(0)}} </span>
                    </v-avatar>
                  </v-card>

                  <!-- Message Bubble -->
                  <!-- <v-row class="" v-if="message.attachments"> -->

                  <!-- </v-row> -->
                  <v-card flat tile class="overflow-visible bg-transparent">
                    <div
                      v-for="(item,index) in message.attachments"
                      :key="index"
                      @click="showPreview(item.DataUrl)"
                    >
                      <div v-if="item.FileType == 'image'">
                        <v-img
                          width="100"
                          height="auto"
                          class="ms-auto mb-1"
                          :src="item.DataUrl"
                        ></v-img>
                      </div>
                      <div v-else-if="item.FileType == 'video'">
                        <video width="200" height="100" controls>
                          <source :src="item.DataUrl" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div v-else-if="item.FileType == 'file'">
                        <div class="csv-card">
                          <div class="card-content">
                            <div class="attachment-item">
                              <div class="item-content">
                                Document

                                <h3 class="file-name">
                                  {{ getFileName(item) }}
                                </h3>
                                <a href="javascript:void(0)" class="ml-2">
                                  <v-icon size="x-large"
                                    >mdi-eye-outline</v-icon
                                  >
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div>{{ getFileName(item) }}</div>
                      <div>
                        <a  href="javascript:void(0)" >Click here </a>
                      </div> -->
                      </div>
                    </div>
                    <v-card
                      flat
                      :class="message.senderType === 'User' ? '' : ''"
                      :color="message.senderType === 'User' ? 'black' : message.color == 'Yellow' ? 'grey-lighten-3': 'grey-lighten-3'"
                      class="message-bubble"
                      v-if="message.text"
                      :max-width="message.senderType === 'User' ? '270px' : ''"
                    >
                      <v-card-text
                        class="position-relative"
                        :class="message.senderType === 'User' ? 'text-white pa-2' : 'text-black pa-2'"
                      >
                        <span v-if="message.senderType === 'User'">
                          {{ message.text }}
                        </span>
                        <span v-else>
                          <template v-if="message.color == 'Yellow'">
                            <div v-html="message.text"></div>
                          </template>
                          <template v-else>
                            <BotResponse
                              :Text="message.text"
                              :IsAllowTypeFormatter="isAllowTypeFormatter"
                            />
                          </template>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-card>
                </div>
                <div
                  v-if="message.senderType === 'LiveAgent' && message.color !='Yellow' && message.text?.length>10"
                  class="ml-12"
                >
                  <v-btn
                    icon
                    variant="text"
                    size="25"
                    color="grey"
                    @click="isPlaying && message.messageId == speakMessageId ? stop() : readAloud(message.text,message.messageId)"
                  >
                    <v-icon class="fs-20px"
                      >{{isPlaying && message.messageId == speakMessageId ?
                      'mdi-stop-circle' : 'mdi-volume-high' }}</v-icon
                    >
                    <v-tooltip activator="parent" location="bottom"
                      >Read aloud</v-tooltip
                    >
                  </v-btn>
                  <v-btn
                    color="grey"
                    icon
                    variant="text"
                    size="25"
                    @click="copyMessage(message)"
                  >
                    <v-icon class="fs-20px"
                      >{{copied && messageId == message.messageId ?
                      'mdi-clipboard-check-outline' :
                      'mdi-clipboard-outline'}}</v-icon
                    >
                    <v-tooltip activator="parent" location="bottom"
                      >Copy</v-tooltip
                    >
                  </v-btn>
                  <v-btn
                    color="grey"
                    icon
                    variant="text"
                    size="25"
                    @click="message.commends == 'Good' ? '' :thumbsCommends('Good',message.messageId,'LiveChat')"
                  >
                    <v-icon class="fs-20px"
                      >{{message.commends == 'Good' ? 'mdi-thumb-up' :
                      'mdi-thumb-up-outline'}}</v-icon
                    >
                  </v-btn>
                  <v-btn
                    icon
                    color="grey"
                    size="25"
                    variant="text"
                    @click="message.commends == 'Bad' ? '' :thumbsCommends('Bad',message.messageId,'LiveChat')"
                  >
                    <v-icon class="fs-20px"
                      >{{message.commends == 'Bad' ? 'mdi-thumb-down' :
                      'mdi-thumb-down-outline'}}</v-icon
                    >
                  </v-btn>
                </div>
              </div>
              <!-- <div class="">
              <div class="typing-loader"></div>
              <span>
                Waiting
              </span>
            </div> -->

              <!-- Typing Indicator -->
              <div class="d-flex align-center mb-3" v-if="isLiveAgentTyping">
                <v-avatar color="black" class="mr-2" size="35">
                  <template
                    v-if="Object.keys(ChatLiveAgentDetails??{})?.length != 0"
                  >
                    <v-img
                      v-if="ChatLiveAgentDetails.Avatarurl"
                      :src="ChatLiveAgentDetails.Avatarurl"
                      width="80"
                      height="80"
                    >
                    </v-img>
                    <span v-else>
                      {{ChatLiveAgentDetails?.AvailableName.charAt(0)}}
                    </span>
                  </template>
                  <template v-else>
                    <v-icon>mdi-emoticon</v-icon>
                  </template>
                </v-avatar>
                <div class="typing-loader"></div>
              </div>
            </div>
          </v-stepper-window-item>
        </v-stepper-window>
      </v-stepper>
      <div v-if="!isLiveAgent && !isAIResponseProcessing && !isOpenLogin">
        <template
          v-for="(item,index) in initialPromptsQuestion"
          :key="index"
          v-if="isShowInitialQuestions && followUpPrompts?.length == 0 && initialPromptsQuestion?.length !=0 && !isHideInitialPromptsQuestion"
        >
          <div
            class="follow-up-container d-flex flex-row align-center justify-end mt-3 text-truncate"
          >
            <v-btn
              class="follow-up-btn text-none"
              color="primary"
              variant="outlined"
              rounded
              @click="triggerAIChat(item)"
            >
              {{item}}
              <v-tooltip activator="parent" location="bottom">
                {{ item }}
              </v-tooltip>
            </v-btn>
          </div>
        </template>
        <template
          v-for="(item,index) in followUpPrompts"
          :key="index"
          v-if=" followUpPrompts?.length > 0 && userAIChatCount < 3 && aiChatBotKeys?.FeatureFlags?.IsShowFollowupPrompts"
        >
          <div
            class="follow-up-container d-flex flex-row align-center mt-3 text-truncate justify-end"
          >
            <v-btn
              class="follow-up-btn text-none"
              color="primary"
              variant="outlined"
              rounded
              @click="triggerAIChat(item)"
            >
              {{item}}
              <v-tooltip activator="parent" location="bottom">
                {{ item }}
              </v-tooltip>
            </v-btn>
          </div>
        </template>
      </div>
      <!-- Chat Messages -->
      <v-sheet class="chat-messages" v-if="!isOpenLogin">
        <!-- v-if="isShowTextField" -->
        <div
          class="position-fixed w-100 bg-white pa-3 left-0 right-0 zi-9999"
          style="bottom: 0px"
          ref="dropZoneRef"
          @paste="handlePaste"
        >
          <v-card
            class="border d-inline-block me-1 pa-2"
            v-if="previewFiles?.length>0"
            v-for="(item,index) in previewFiles"
            :key="index"
            @click="showPreview(item.DataUrl)"
          >
            <v-img
              v-if="item.FileType.includes('image')"
              width="60"
              height="60"
              :src="item.DataUrl"
            ></v-img>
            <video
              v-else-if="item.FileType.includes('video')"
              width="90"
              height="90"
            >
              <source :src="item.DataUrl" type="video/mp4" />
            </video>
            <span v-else-if="item.FileType.includes('file')">
              {{ getFileName(item) }}
            </span>
            <v-btn
              icon
              variant="text"
              color="grey"
              class="position-absolute top-0 right-0"
              size="25"
              @click.stop="removeFile(index)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card>
          <!-- <v-card v-if="selectFiles.length>0" class="mb-1 border d-inline-block">
            <v-row class="mt-3">
              <span v-for="(item,index) in selectFiles" :key="index">
                <v-col>
                  <v-badge>
                    <template #default>
                      
                    </template>
                    <template #badge>
                      
                    </template>
                  </v-badge>
                </v-col>
              </span>
            </v-row>
          </v-card> -->

          <!-- <div>
          <h1>Speech Recognition Example</h1>
          <v-btn  varient="plain" @click="startListening">Start Listening</v-btn>
          <v-btn varient="plain"  @click="stopListening">Stop Listening</v-btn>
          <p v-if="transcribedText">Transcript: {{ transcribedText }}</p>
        </div> -->

          <v-textarea
            v-model.trim="chatMessage"
            class="text-grey card-shadow border-0 border border-grey border-opacity-30 overflow-auto"
            style="border-radius: 30px"
            variant="outlined"
            max-rows="4"
            @keyup.enter="isRestrictToClick ? '' : submit()"
            @input="isTypingOn = true"
            @blur="isTypingOn = false"
            hide-details="auto"
            auto-grow
            rows="1"
            :placeholder="isLiveAgent ? 'You Ask, we answer...': 'You Ask, we answer...'"
          >
            <template v-slot:prepend-inner>
              <v-btn
                @click="isShowEmojiPicker = true"
                icon
                id="emoji-menu-activator"
                variant="text"
                color="black"
                size="30"
              >
                <v-icon>mdi-emoticon-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:append-inner>
              <v-btn
                size="30"
                class="me-1"
                v-if="isLiveAgent"
                variant="text"
                icon
                @click="fileInput?.click()"
              >
                <v-icon>mdi-paperclip</v-icon>
                <v-tooltip activator="parent" location="bottom">
                  Drag and drop or paste or attach images
                </v-tooltip>
              </v-btn>
              <v-file-input
                ref="fileInput"
                v-model="selectInputFiles"
                class="d-none"
                multiple
                accept="image/jpeg,image/png,image/gif,video/mp4,application/pdf"
                @update:modelValue="handleFileInputChange"
              ></v-file-input>
              <v-btn
                color="primary"
                class="elevation-0 rounded-pill"
                size="35"
                :disabled="isSendButtonLoader ? false : isRestrictToClick"
                :loading="isSendButtonLoader"
                @click="submit"
                :class="{ 'cursor-not-allowed ': isWaitingLoader && !isLiveAgent }"
              >
                <v-icon>mdi-arrow-up</v-icon>
                <template v-slot:loader>
                  <v-progress-circular
                    color="grey-lighten-1"
                    indeterminate
                    size="16"
                    width="2"
                  ></v-progress-circular>
                  <!-- <v-icon>mdi-arrow-up</v-icon> -->
                </template>
              </v-btn>
              <!-- <v-avatar class="cursor-pointer" :color="isRestrictToClick ? 'disable' : 'primary'">
                <v-icon
                  :disabled="isRestrictToClick"
                  @click="submit"
                  :color="isRestrictToClick ? 'grey opacity-1 ' : 'white opacity-1'"
                  :class="{ 'cursor-not-allowed ': isWaitingLoader && !isLiveAgent }"
                >
                  mdi-arrow-up
                </v-icon>
              </v-avatar> -->
            </template>
          </v-textarea>
          <v-menu activator="#emoji-menu-activator" offset="15 -10">
            <Picker
              :data="emojiIndex"
              set="twitter"
              @select="showEmoji"
              :showPreview="false"
              :showCategories="false"
            />
          </v-menu>
        </div>
        <!-- <div v-else>
          For additional help, click here to start a new conversation with a live agent.
          <div class="text-center">
          <v-btn
          class="text-capitalize mt-4"
          variant="outlined"
          color="secondary"
          @click="newChat()"
        >
          <v-icon class="me-2">mdi-plus</v-icon>
            Start New Chat
        </v-btn>
      </div>
        </div> -->
      </v-sheet>

      <transition
        v-if="isOpenLogin"
        name="slide-x-reverse-transition"
        class="pa-3"
      >
        <UserLogin
          ref="userLoginRef"
          @ContinueChat="continueChat"
          callFrom="ChatWidget"
        />
      </transition>
    </v-card>
  </div>
</v-sheet>
